import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import AccountDetail from '@app/views/Account/Detail';
import { memo } from 'react';

export default memo(
  withIfUser(AccountDetail)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
